import React, { useState, useEffect } from 'react';
import {
  Container,
  Form,
  Col,
  Row,
  Stack,
  Image,
  Button,
} from 'react-bootstrap';
// import sanitizehtml from '../utils/sanitizeHTML';
import axios from 'axios';
import { config } from '../config/config';

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

var modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [{ direction: 'rtl' }],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    [{ color: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ['link', 'image'],
    ['clean'],
  ],
};

var formats = [
  'header',
  'bold',
  'italic',
  'font',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'color',
  'direction',
  'align',
  'link',
  'image',
];

const CreateBlog = () => {
  const [editorValue, setEditorValue] = useState('');
  const [formData, setFormData] = useState({
    title: '',
    blog: '',
    categories: ['Health', 'Nutrition'],
    image: null,
  });

  const [selectedImage, setSelectedImage] = useState(null);

  const { title, categories, image } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // setFormData({ ...formData, blog: editorValue });
    try {
      console.log(formData);
      const request = await axios.post(
        'https://provider.numente.io/blog/create-blog',
        formData,
        config
      );
      if (request.data.success === true) {
        alert('Blog created');
      } else {
        alert('Could not create blog');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleImageUpload = () => {
    const fileInput = document.getElementById('fileInput');
    fileInput.click();
  }

  const handleImage = (e) => {
    setSelectedImage(e.target.files[0]);
    setFormData({ ...formData, image: window.URL.createObjectURL(selectedImage) })
  }

  useEffect(() => {
    if (editorValue) {
      setFormData({ ...formData, blog: editorValue });
    }
  }, [editorValue]);
  console.log(image)
  return (
    <>
      <Container>
        <div className=' p-4 my-4'>
          <h2 className='f2-2 mb-0 fw-semibold '>Content</h2>
        </div>

        <Form onSubmit={handleSubmit}>
          <div className='shadow rounded p-4 my-4'>
            <div className='border-bottom mb-3'>
              <h4 className='fs-4 fw-medium text-secondary'>New Health & Wellness Content</h4>

            </div>
            {/* Title and Photo */}
            <Row>
              {/* Photo grid */}
              <Col>
                <Row className='mb-2'>
                  <Col xs={6} md={4}>
                    <div
                      id='imageDiv'
                      className='d-flex justify-content-center align-content-center  rounded'
                      style={{ width: 100, height: 100, background: "#D9D9D9" }}
                      onClick={handleImageUpload}
                    >
                      <img src={image ? image : '/images/image1.png'} alt='l....' />
                      <input id='fileInput' type='file' accept="image/png, image/jpeg" onChange={handleImage} />
                    </div>
                  </Col>
                </Row>
                <Row>
                  {/* <Form.Group controlId='formFile' className='mb-3'>
                    <Form.Label>Choose Image</Form.Label>
                    <Form.Control type='file' />
                  </Form.Group> */}
                </Row>
              </Col>
              {/* Data Grid */}
              <Col xs={9}>
                <Row>
                  <Col xs={8}>
                    <Form.Group className='py-4 mb-2' controlId='forTitle'>
                      <Form.Control
                        type='text'
                        placeholder='Enter Title'
                        name='title'
                        onChange={onChange}
                        value={title}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className='py-4 mb-2' controlId='forType'>
                      <Form.Control
                        type='text'
                        placeholder='Enter Type'
                        name='categories'
                        value={categories}
                      // onChange={onChange}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Col>
            </Row>
            <hr />
            {/* Text Editor */}
            <Container className='container'>
              <Row className='pb-4 mx-2'>
                <Col>
                  <ReactQuill
                    onChange={setEditorValue}
                    modules={modules}
                    formats={formats}
                    placeholder='Start Writing here'
                    theme='snow'
                  />
                </Col>
              </Row>
            </Container>
          </div>
          <div>
            <Row>
              <Stack direction='horizontal' gap={3}>
                <div className='py-4'>
                  <Button type='submit' variant='primary'>
                    Save
                  </Button>
                </div>
                <div className='py-4'>
                  <Button variant='danger'>Cancel</Button>
                </div>
              </Stack>
            </Row>
          </div>
        </Form>
      </Container>
    </>
  );
};

export default CreateBlog;
